function InitializeAmiLocationType() {
    $('#AmiFaxnumbers input[type=checkbox]').click(function () {
        AmiFaxNumbersClick();
    });
    AmiFaxNumbersClick();
}
function AmiFaxNumbersClick() {
    if ($('#AmiFaxnumbers input[type=checkbox]').prop('checked')) {
        $('#AmiRemoveFaxDuplicates').show();
    }
    else {
        $('#AmiRemoveFaxDuplicates').hide();
    }
}